import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, ButtonGroup } from "reactstrap";
import {
  getStudentDetails,
  getStudentInvoices,
  getStudentPrograms,
} from "../../../actions/emActions";
import { imageLink } from "../../../actions/utility";
import HeaderComponent from "../../website/HeaderComponent";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import emptyImage from "../../../public/images/empty.svg";
import "./studentDetails.scss";
import CoursesDetails from "./CoursesDetails";
import Invoices from "./Invoices";
import ReferralTo from "./ReferralTo";
import { Link } from "react-router-dom";

const StudentDetails = (props) => {
  const [studentInfo, setstudentInfo] = useState([]);
  const [userName, setuserName] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setemail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [loginName, setloginName] = useState("");
  const [activeTab, setactiveTab] = useState(1);
  const [programData, setprogramData] = useState([]);
  const [allInvoices, setallInvoices] = useState({});
  const [referralCount, setreferralCount] = useState("");
  useEffect(() => {
    getStudentDetails(2, props.match.params.id).then((res) => {
      setstudentInfo(res.data);
      setfirstName(res.data.lm_candidate_profile[0].first_name);
      setlastName(res.data.lm_candidate_profile[0].last_name);
      setemail(res.data.user_email);
      setuserName(res.data.user_name);
      setloginName(res.data.user_loginname);
      setphoneNumber(res.data?.lm_candidate_profile[0].phone);
      setreferralCount(res?.data?.referral_count);
    });

    getStudentPrograms(props.match.params.id).then((res) => {
      setprogramData(res.data);
    });

    getStudentInvoices(props.match.params.id).then((res) => {
      setallInvoices(res.data);
    });
  }, []);

  const numberOfPrograms = programData?.filter((item) => item.status === 1).length;
  const StudentfirstName = studentInfo?.lm_candidate_profile?.[0]["first_name"];
  return (
    <div>
      <div className="AllStudensComponent">
        <HeaderComponent />
        <div style={{ padding: "2vh 0" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <RightSectionEM />
              </div>

              <div className="col-md-9 studentDetails mb-5">
                <div className="cover"></div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-2">
                      <img
                        className="roundedAvatarOverlay"
                        src={studentInfo.image !== null ? imageLink(studentInfo.image) : emptyImage}
                      />
                    </div>
                    <div className="col-md-10">
                      <div className="d-block d-md-flex ml-3 justify-content-between marginOnMobile80Px">
                        <div>
                          <label className="userName mb-0">{studentInfo.user_name} </label>
                          <br />
                          <label className="generalText mb-0">
                            {" "}
                            <i className="fa fa-envelope mr-2 iconColor"></i>
                            {studentInfo.user_email}
                          </label>
                          <br />
                          <label className="generalText mb-0">
                            <i className="fa fa-phone mr-2 iconColor"></i> +
                            {studentInfo?.lm_candidate_profile?.[0]["phone"]}
                          </label>
                          <br />
                          <label className="generalText mb-0">
                            <i className="fa fa-graduation-cap mr-1 iconColor"></i>{" "}
                            {numberOfPrograms} Courses{" "}
                          </label>
                          <br />
                          <label className="generalText">
                            <i className="fa fa-money mr-1 iconColor"></i>{" "}
                            <span className="text-danger"> Rs {allInvoices.unpayedAmount} Due</span>{" "}
                          </label>
                        </div>
                        <div className="my-auto">
                          <label className="generalText">
                            <i className="fa fa-clock-o mr-1 iconColor"></i> Since{" "}
                            {moment(studentInfo.ts).format("Do MMM 'YY")}
                          </label>

                          <div>
                            {studentInfo?.siblings?.length > 0 && (
                              <label className="mb-0">{StudentfirstName}'s siblings:</label>
                            )}
                            {studentInfo?.siblings &&
                              studentInfo?.siblings.map(
                                (siblings, index) =>
                                  index < 2 && (
                                    <Link
                                      to={`/dashboards/StudentDetails/${siblings.id}`}
                                      // onClick={() => window.location.reload()}
                                    >
                                      <div className="siblingsImg mt-1 d-flex">
                                        <div className="smallAvatar">
                                          <img
                                            src={
                                              siblings.image !== null
                                                ? imageLink(siblings.image)
                                                : emptyImage
                                            }
                                            className=""
                                          />
                                        </div>

                                        <div>
                                          <label className="generalText ml-2 mt-2">
                                            <span className="text-primary">
                                              {siblings.user_name}
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                    </Link>
                                  )
                              )}
                          </div>
                          {/* <div>
                            <div className="siblingsImg mt-1 d-flex">
                              <div className="smallAvatar">
                                <img
                                  src="https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1594283790_up_547807745.jpeg"
                                  className=""
                                />
                              </div>
                              <div className="smallAvatar">
                                <img
                                  src="https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/lmprofile_1653543466_up_98372113.jpeg"
                                  className=""
                                />
                              </div>
                              <div>
                                <label className="generalText ml-2 mt-2">
                                  <span className="text-primary">Maraib</span> &{" "}
                                  <span className="text-primary">Zaimal</span>
                                  &nbsp;are siblings of Inara.
                                </label>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        <div className="my-auto">
                          <a target="__blank" href={`/#/${studentInfo?.hashId}`}>
                            <button className="goToFeeds">
                              {StudentfirstName}'s feeds <i className="fa fa-arrow-right "></i>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabSection">
                        <ButtonGroup>
                          <Button
                            onClick={() => setactiveTab(1)}
                            className={activeTab === 1 ? "tabsButtonActive" : "tabsButton"}
                          >
                            Personal
                          </Button>
                          <Button
                            onClick={() => setactiveTab(2)}
                            className={activeTab === 2 ? "tabsButtonActive" : "tabsButton"}
                          >
                            Courses
                          </Button>
                          <Button
                            onClick={() => setactiveTab(3)}
                            className={activeTab === 3 ? "tabsButtonActive" : "tabsButton"}
                          >
                            Invoices
                          </Button>
                          <Button
                            onClick={() => setactiveTab(4)}
                            className={activeTab === 4 ? "tabsButtonActive" : "tabsButton"}
                          >
                            Referral Details
                          </Button>
                        </ButtonGroup>
                      </div>

                      <div className="tabsContentData p-3">
                        {activeTab === 1 ? (
                          <div>
                            <div className="row">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">Full name:</label>
                                  <br />
                                  <input
                                    value={userName}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">Email:</label>
                                  <br />
                                  <input
                                    value={email}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-4">
                                <div>
                                  <label className="fieldLabel">Contact number:</label>
                                  <br />
                                  <input
                                    value={phoneNumber}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Login Name:</label>
                                  <br />
                                  <input
                                    value={loginName}
                                    placeholder=""
                                    className="studentField"
                                    type="text"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Password:</label>
                                  <br />
                                  <input placeholder="" className="studentField" type="text" />
                                </div>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-4 mt-2">
                                <div>
                                  <label className="fieldLabel">Notes:</label>
                                  <br />
                                  <textarea placeholder="" className="studentField" type="text" />
                                </div>
                              </div>
                              <div className="col-md-8 text-right my-auto">
                                <div className="">
                                  <button className="saveBtn">Update Information</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : activeTab === 2 ? (
                          <CoursesDetails
                            studentsProgram={programData}
                            studentId={props.match.params.id}
                          />
                        ) : activeTab === 3 ? (
                          <Invoices studentId={props.match.params.id} />
                        ) : (
                          <ReferralTo
                            studentId={props.match.params.id}
                            studentName={StudentfirstName}
                            referralCount={referralCount}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
